import {
    GET_TENANTS,
    ADD_TENANT,
    UPDATE_TENANT,
    DELETE_TENANT,
    SET_LOADING,
    SET_ERROR,
    GET_TENANT_STATS
} from "./tenantsActions";

const tenantsReducer = (state, action) => {
    switch (action.type) {
        case GET_TENANTS:
            return {
                ...state,
                tenants: action.payload,
                loading: false
            };

        case ADD_TENANT:
            return {
                ...state,
                tenants: [...state.tenants, action.payload],
                loading: false
            };

        case UPDATE_TENANT:
            return {
                ...state,
                tenants: state.tenants.map(t =>
                    t._id === action.payload._id ? action.payload : t
                ),
                loading: false
            };

        case DELETE_TENANT:
            return {
                ...state,
                tenants: state.tenants.filter(t => t._id !== action.payload._id),
                loading: false
            };

        case SET_LOADING:
            return {
                ...state,
                loading: action.payload
            };

        case SET_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };

        case GET_TENANT_STATS:
            return {
                ...state,
                stats: action.payload,
                loading: false
            };

        default:
            return state;
    }
}

export default tenantsReducer;
